import React from 'react';
import { Countdown, PriceCard } from './Shared';
export const FinalCtaSection = () => {
  return <section className="bg-familia-bg border-t border-familia-cyan/30 py-10 md:py-16 px-4 md:px-6" data-id="element-77">
      <div className="max-w-7xl mx-auto text-center w-[92%] md:w-full" data-id="element-78">
        <h2 className="text-familia-red font-bold text-base sm:text-xl md:text-2xl mb-8 md:mb-12 animate-blink uppercase tracking-widest text-center" data-id="element-79">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>
        <Countdown className="mb-10 md:mb-20" data-id="element-80" />
        <div className="mb-10 md:mb-20 flex justify-center" data-id="element-81">
          <PriceCard data-id="element-82" />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-4xl mx-auto" data-id="element-83">
          {['5 Módulos + Módulo Maestro + 3 Bonos', '+240 páginas de contenido premium', 'Acceso inmediato', 'Garantía 7 días'].map((item, i) => <div key={i} className="bg-familia-card border border-familia-cyan/15 p-4 rounded-xl flex items-center justify-center gap-3" data-id="element-84">
              <span className="text-familia-green" data-id="element-85">✅</span>
              <span className="text-xs font-bold uppercase tracking-wider" data-id="element-86">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
};